export default [{
	titulo: 'Professores Temporários',
	icone: 'menu-icon fa fa-caret-right',
	url: '/servicos/professores-temporarios',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]